// actionTypes.js
export const SET_VALUE_ModeleAugCap = "SET_VALUE_ModeleAugCap";
export const SET_TYPE_ModeleAugCap = "SET_TYPE_ModeleAugCap";
export const SET_CURRENT_PAGE_ModeleAugCap = "SET_CURRENT_PAGE_ModeleAugCap";
export const SET_ORDER_ModeleAugCap = "SET_ORDER_ModeleAugCap";
export const SET_SORT_FIELD_ModeleAugCap = "SET_SORT_FIELD_ModeleAugCap";
export const SET_ACTIF_ModeleAugCap = "SET_ACTIF_ModeleAugCap";
export const SET_CATEGORIE_ModeleAugCap = "SET_CATEGORIE_ModeleAugCap";
